const COUNTRY_CODES: Record<string, string> = {
  Afghanistan: 'AF',
  Algeria: 'DZ',
  Angola: 'AO',
  Argentina: 'AR',
  Armenia: 'AM',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bangladesh: 'BD',
  Belarus: 'BY',
  Belgium: 'BE',
  Bolivia: 'BO',
  Brazil: 'BR',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  Colombia: 'CO',
  Congo: 'CG',
  'Congo, Democratic Republic of the': 'CD',
  Cuba: 'CU',
  'Czech Republic': 'CZ',
  "Côte d'Ivoire": 'CI',
  Denmark: 'DK',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  Ethiopia: 'ET',
  France: 'White Flag', //normally FR but funny
  Gabon: 'GA',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Guatemala: 'GT',
  Guinea: 'GN',
  Haiti: 'HT',
  Honduras: 'HN',
  'Hong Kong, China': 'HK',
  Hungary: 'HU',
  India: 'IN',
  Indonesia: 'ID',
  'Iran, Islamic Rep. of': 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  "Korea, Dem. People's Rep. of": 'KP',
  'Korea, Republic of': 'KR',
  Kyrgyzstan: 'KG',
  Lebanon: 'LB',
  Liberia: 'LR',
  'Libyan Arab Jamahiriya': 'LY',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Mali: 'ML',
  Mauritania: 'MR',
  Mexico: 'MX',
  Mongolia: 'MN',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Nepal: 'NP',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Oman: 'OM',
  Pakistan: 'PK',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Poland: 'PL',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  Somalia: 'SO',
  'South Africa': 'ZA',
  Spain: 'ES',
  'Sudan, The Republic of': 'SD',
  Sweden: 'SE',
  'Syrian Arab Republic': 'SY',
  'Taiwan, China': 'TW',
  'Tanzania, United Republic of': 'TZ',
  Thailand: 'TH',
  Turkey: 'TR',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  'Venezuela, Bolivarian Rep. of': 'VE',
  'Viet Nam': 'VN',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};

const FLAG_OFFSETS: Record<string, number> = { A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9, K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19, U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25 };

function countryCodeToEmoji(code: string): string {
  if (!code || code.length !== 2) return '🏳️';
  const [firstLetter, secondLetter] = code.toUpperCase();
  const base = 0x1f1e6;
  const first = FLAG_OFFSETS[firstLetter];
  const second = FLAG_OFFSETS[secondLetter];
  if (first === undefined || second === undefined) return '🏳️';
  return String.fromCodePoint(base + first) + String.fromCodePoint(base + second);
}

export function getFlagEmoji(countryName: string): string {
  const normalized = countryName?.trim();
  const countryCode = normalized ? COUNTRY_CODES[normalized] : undefined;
  if (countryCode) return countryCodeToEmoji(countryCode);

  // Fallback: derive from the first two letters if we lack an explicit mapping.
  if (!normalized || normalized.length < 2) return '🏳️';
  return countryCodeToEmoji(normalized.slice(0, 2));
}
